import { slugify } from '@bridebook/toolbox/src';
import { Box, ButtonV2, Container } from '@bridebook/ui';
import { IconAdd } from '@bridebook/ui/src/icons';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { getFaqData } from '@bridebook/web/app-shared/lib/landing/faq-data';
import { LandingPageIds } from '@bridebook/web/lib/landing/webflow-page-urls';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import componentStyles from './faq-section.style';
import Markdown from 'markdown-to-jsx';

interface IProps {
  pageId: LandingPageIds;
}

export const FaqSection = ({ pageId }: IProps) => {
  const pageData = getFaqData()[pageId]?.();

  if (!pageData) return null;

  const { button, data, header, subheader } = pageData;

  const styles = componentStyles();

  return (
    <Container style={styles.wrapper}>
      <Box style={styles.header}>{header}</Box>
      <Box style={styles.subheader}>{subheader}</Box>
      {data.map((item) => (
        <Box as="details" style={styles.itemWrap} key={slugify(item.question)}>
          <Box as="summary" style={styles.question}>
            {item.question}
            <span>
              <IconAdd width={15} />
            </span>
          </Box>
          <Box style={styles.answer}>
            <Markdown>{item.answer}</Markdown>
          </Box>
        </Box>
      ))}
      <Box style={styles.buttonWrap}>
        <Link href={UrlHelper.signup}>
          <ButtonV2 variant="primary">{button}</ButtonV2>
        </Link>
      </Box>
    </Container>
  );
};
